// PC俱乐部列表
export const getClubList = function (params) {
  return this.$http('get', '/club/api/page', params)
}
